window.NotesAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    self.getCandidateNotes = function (brandId, candidateId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }
        if (!candidateId) {
            throw "No candidate id";
        }

        _protected.request('brands/' + brandId + '/candidates/' + candidateId + '/comments', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createCandidateNote = function (brandId, params) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/candidates/comments', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

});
